const LayoutIcon = ({ type }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {type === 'left' && (
      <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM9 6H6V18H9V6Z" fill="currentColor"/>
    )}
    {type === 'centered' && (
      <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM8 6H16V18H8V6Z" fill="currentColor"/>
    )}
    {type === 'right' && (
      <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM18 6H15V18H18V6Z" fill="currentColor"/>
    )}
  </svg>
);


export const FONT_OPTIONS = [
  { key: "verdana", label: "Verdana", preview: "Verdana", fallback: "Verdana" },
  { key: "georgia", label: "Georgia", preview: "Arial", fallback: "Georgia" },
  { key: "garamond", label: "Garamond", preview: "Garamond", fallback: "Garamond" }
];

export const LAYOUTS = [
  { key: "left", label: "Left Column", icon: <LayoutIcon type="left" /> },
  { key: "centered", label: "Centered", icon: <LayoutIcon type="centered" /> },
  { key: "right", label: "Right Column", icon: <LayoutIcon type="right" /> },
];

export const SPACING_OPTIONS = [
  { key: "dense", label: "Dense", icon: "↑↓" },
  { key: "normal", label: "Normal", icon: "↑↓" },
  { key: "loose", label: "Loose", icon: "↑↓" }
];

export const COLOR_OPTIONS = [
  {key: "black", backgroundColor: 'white', textColor: 'black', viewBackgroundColor: 'white', viewInnerColor: '#000'},
  {key: 'lightblue', backgroundColor: '#e2f1fe', textColor: '#000000' , viewBackgroundColor: 'white',  viewInnerColor: '#e2f1fe'},
  {key: 'lightgreen', backgroundColor: '#d4faf1', textColor: '#234d4a', viewBackgroundColor: '#d4faf1', viewInnerColor: '#3d9188'},
  {key: 'yellow', backgroundColor: '#f7edc6', textColor: '#171717', viewBackgroundColor: '#fff', viewInnerColor: '#f7edc6'},
  {key: 'red', backgroundColor: '#fdf1f2', textColor: '#171717', viewBackgroundColor: '#fff', viewInnerColor: '#d23b4a'},
]

export const getColorInfo = colorKey => {
  return COLOR_OPTIONS.find(option => option.key === colorKey);
}

export const TEMPLATES = [
  { key: "bentz", label: "Bentz", img: "/template-bentz.png" },
  { key: "hopper", label: "Hopper", img: "/template-hopper.png" },
  { key: "lamarr", label: "Lamarr", img: "/template-lamarr.png" },
  { key: "nick", label: "Nick", img: "/template-nick.png" },
];